<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      readonly
      :disabled="isDisabled"
      :state="state"
      :value="selectedValue"
      :placeholder="placeholder"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
      <v-icon v-if="value !== null && value !== ''" name="buttons/cross" :size="11"/>
      <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
      <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
    </button>

    <div v-if="isFocus" class="custom-dropdown-select" :class="{ 'drop-up': dropUp }">
      <div class="custom-dropdown-list-scroll">
        <div
            v-for="(item, index) in options"
            :key="index"
            class="custom-dropdown-select-item"
            :class="{ 'active': item.value === value }"
            @mousedown.prevent="onSelect(item)"
        >
          <span class="text-small">{{ item.text }}</span>
        </div>
      </div>

      <div v-if="options.length === 0" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseSelect",
  props: {
    value: { type: [String, Number], default: null },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
    isDisabled: { type: Boolean, default: false },
    state: { type: Boolean, default: null },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isFocus: false
    };
  },
  computed: {
    selectedValue() {
      const selected = this.options.find(item => item.value === this.value);
      return selected ? selected.text : '';
    }
  },
  methods: {
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClick() {
      if (this.value !== null && this.value !== '') {
        this.onClear();
      } else {
        this.onFocusIn();
      }
      this.$refs.input_ref.$el.focus();
    },
    onSelect(item) {
      this.$emit('onSelect', item);
      this.onFocusOut();
    },
    onClear() {
      this.$emit('onSelect', null);
    }
  }
}
</script>

<style>
.custom-dropdown-select.drop-up {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/BaseSelect.vue